module.exports = ['$scope', '$location', ($scope, $location) ->
  @sort = {
    orderBy: $location.search().orderBy
    reverse: $location.search().reverse is "true"
  }

  @onSort(@sort) if @onSort

  @sortBy = (value, reverse = false) ->
    @sort.orderBy = value
    @sort.reverse = reverse
    @onSort(@sort) if @onSort
    $location.replace().search _.merge($location.search(), { orderBy: @sort.orderBy, reverse: String(@sort.reverse) })

  @
]
